import {sx} from './sx'
import {Box} from "@mui/material";
import Sidebar from "@view/sidebar/Sidebar";
import {useMedia} from "@hooks/ui/useMedia";
import {useAuthContext} from "@containers/auth/context/hooks/useAuthContext";
import {ReactNode} from "react";
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import {classNames} from "@helpers/classNames";
import Header from "@view/header/Header";
import {useViewContext} from "@context/viewContext/hooks/useViewContext";
import {buildClassNamesThemes} from "@view/layout/helpers/buildClassNamesThemes";
import {ChatProvider} from "@containers/chat/ChatProvider";
import {useLocation} from "react-router-dom";
import ErrorBoundaryCustom from "@ui/errorBoundary/ErrorBoundaryCustom";
import AccountStyleProvider from "@containers/accountStyle/context/AccountStyleProvider";

interface IProps {
    children: ReactNode
}

const LayoutRoot = ({children}: IProps) => {

    const {isDesktop} = useMedia()
    const {isAuth} = useAuthContext()
    const {hideSidebar} = useViewContext()
    const {theme, themeSize} = useThemeContext()
    const {pathname} = useLocation()


    if (!isAuth) {
        return (
            <ErrorBoundaryCustom resetKey={pathname}>
                {children}
            </ErrorBoundaryCustom>
        )
    }

    return (
        // ChatProvider — глобальний чат (іконка в шапці, сповіщення, модалка); доступний
        // усім екранам через useChat().openChat(...)
        <ChatProvider>
            <AccountStyleProvider>
                <Box
                    className={classNames(
                        buildClassNamesThemes({
                            theme,
                            themeSize
                        }),
                        hideSidebar && 'hideSidebar'
                    )}
                    sx={sx.container}
                >
                    <Box
                        sx={sx.header}
                    >
                        <Header/>
                    </Box>

                    {isDesktop && !hideSidebar && <Box
                        sx={sx.sidebar}
                    >
                        <Sidebar/>
                    </Box>}

                    <Box
                        sx={sx.content}
                    >
                        <ErrorBoundaryCustom resetKey={pathname}>
                            {children}
                        </ErrorBoundaryCustom>
                    </Box>
                </Box>
            </AccountStyleProvider>
        </ChatProvider>
    )
};

export default LayoutRoot;